export const formatPageTitle = (subTitle: string) => `HMD Mobile - ${subTitle}`
